module.exports = __webpack_public_path__ + "static/img/sec3-content-img01@t.063a3dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/hanssem/sec3-content-img01@t.jpg
// module id = s49V
// module chunks = 0